import React from 'react';

import TitleContainer from '../TitleContainer/TitleContainer';

import WhatsAppIcon from '@mui/icons-material/WhatsApp';


const ExpiredMembreship = () => {
  return (
    <>
      <section className="w-[90%] md:w-[70%] mx-auto mb-4">
        <div className="md:h-[3vh] w-full"></div>
        <div className="md:block hidden">
          <TitleContainer
            title='Volver al inicio'
            subtitle=""
            rutaEspecifica="/"
          />
        </div>
        <div className="md:hidden block">
          <TitleContainer
            title='Volver al inicio'
            subtitle=""
            twoArrows
            subtitle1=""
            rutaEspecifica="/"
          />
        </div>
      </section>
      <div className='flex flex-col justify-center items-center h-[50vh] mx-3'>
        <p className="semi-bold text-lg md:text-xl">&nbsp;Tu membresía no está activa en este momento. Renueva tu membresía para acceder al programa y continuar con tus entrenamientos.</p>
        <a 
          className='flex items-center mb-2 no-underline hover:underline active:underline-offset-2 font-medium text-lg md:text-xl w-fit self-center'
          target='blank'
          href="https://wa.link/fo3nfi"
        >
          <WhatsAppIcon /> Activa aquí tu membresía
        </a>
      </div>
    </>
  )
}

export default ExpiredMembreship;